import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import { ViewInspector, ViewInspectorCollection } from './queryBuilder';

const useSelectedSiteDisciplineInspectors = (siteId: number, disciplineId: number) => {
  const getViewInspectorQuery = useCallback(
    (collection: ViewInspectorCollection) =>
      collection?.find({
        selector: {
          $and: [
            { siteId: { $eq: siteId } },
            { disciplineId: { $eq: disciplineId } },
            { isActive: { $eq: true } },
            {
              $or: [{ fieldInspectorId: { $ne: null } }, { clerkId: { $ne: null } }],
            },
          ],
        },
      }),
    [siteId, disciplineId],
  );

  const { result: inspectorData, isFetching: isViewInspectorLoading } = useRxData<ViewInspector>(
    RxdbCollectionName.VIEW_INSPECTOR,
    getViewInspectorQuery,
    {
      json: true,
    },
  );

  return { inspectorData, isViewInspectorLoading };
};

export default useSelectedSiteDisciplineInspectors;
